import { Outlet } from "@remix-run/react";
import LinePattern from "~/assets/line-pattern.svg";
import Logo from "~/assets/logo.svg";
import { Link } from "~/components/Link";

export default function AuthRouteLayout() {
  return (
    <div className="flex h-[100vh]">
      <div className="guest-left-panel hidden md:block md:w-[200px] lg:w-[300px]">
        <Link to="/">
          <img alt="" src={Logo} className="m-5 h-5 w-5" />
        </Link>
        <img alt="" src={LinePattern} className="absolute bottom-0 left-0" />
      </div>
      <div className="flex-1">
        <div className="mx-auto w-80 py-16 md:w-[335px] md:py-32">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
